import BoxFilters from './filters/BoxFilters';
import React, { useState, useEffect } from 'react';
import Map from './map/Map';
import FloatingSidebar from './sidebar/FloatingSidebar';
import styled from 'styled-components';
import { Column } from 'styled/alignment/Column';
import { useSearchParams } from 'react-router-dom';
import breakpoints from 'theme/breakpoints';
import { useCollapse } from 'context/general/Collapse';
import eventsApi from 'api/requests/events';
import EventDetail from './detail/EventDetail';
import indexPriority from 'theme/z-index';
import { FullyCentered } from 'styled/alignment/Center';
import sizes from 'theme/sizes';
import Loader from 'components/_UI/Loader';
import colors from 'theme/colors';
import { useEventsList } from 'context/events/EventsList';
import EventForm from './form/EventForm';
import { useEvent } from 'context/events/Event';
import DeleteEvent from './delete/DeleteEvent';
import UserLocationModal from './map/UserLocationModal';
import Text from 'components/_UI/Text';
import EventCard from './card/EventCard';
import MultipleEventsList from './map/MultipleEventsList';
import { useBackButtonCollapse } from 'context/general/BackButtonCollapse';

export default function Events() {
    const [searchParams, setSearchParams] = useSearchParams();
    const { backButtonCollapse, setBackButtonCollapse } = useBackButtonCollapse();

    const { collapse, setCollapse } = useCollapse();
    const { eventsList, setEventsList } = useEventsList();
    const { event } = useEvent();

    const [userLocation, setUserLocation] = useState(null)
    // const [userLocationModal, setUserLocationModal] = useState(true)
    
    const [filterData, setFilterData] = useState(null)
    const [latitude, setLatitude] = useState(false)
    const [longitude, setLongitude] = useState(false)
    const [renderMap, setRenderMap] = useState(false);
    const [slug, setSlug] = useState(null);
    const [screenLoading, setScreenLoading] = useState(true);
    const [modalDelete, setModalDelete] = useState(false);

    useEffect(async () => {
        getGeolocationFromUser();
        await getEvents();
        await getEventByRouteParam();
    }, []);

    function getGeolocationFromUser() {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(success, error)
        }
    };

    // function onHandleLocation(address) {
    //     setLatitude(Number(address.lat))
    //     setLongitude(Number(address.long))
    //     // setUserLocationModal(false)
    //     setScreenLoading(true)
    //     setRenderMap(true)
    // }

    async function renderEventDetail(event) {
        setCollapse({
            ...collapse,
            withContent: true,
            height: '85vh',
            arrowPosition: false,
            componentToRender: () => (
                <FullyCentered height='100%'>
                    <Loader />
                </FullyCentered>
            )
        })

        try {
            const { data: res } = await eventsApi.getBySlug(event.slug);
            setCollapse({
                ...collapse,
                withContent: true,
                height: '85vh',
                arrowPosition: false,
                componentToRender: () => event && <EventDetail data={res.data} />
            })
        } catch (error) {
            setCollapse({
                ...collapse,
                withContent: true,
                height: '85vh',
                arrowPosition: false,
                componentToRender: () => (
                    <FullyCentered height='100%'>
                        <Text name='highlight'> Ocorreu um erro inesperado. </Text>
                    </FullyCentered>
                )
            })
        }
    }

    async function renderMultipleEvents(lat, long) {
        setCollapse({
            ...collapse,
            withContent: true,
            height: '85vh',
            arrowPosition: false,
            componentToRender: () => (
                <FullyCentered height='100%'>
                    <Loader />
                </FullyCentered>
            )
        })

        try {
            const { data: res } = await eventsApi.findMultiples({ lat, long })
            setCollapse({
                ...collapse,
                withContent: true,
                height: '85vh',
                arrowPosition: false,
                componentToRender: () => res?.data && <MultipleEventsList data={res.data} />
            })
        } catch (error) {
            <FullyCentered height='100%'>
                <Text name='highlight'> Ocorreu um erro inesperado. </Text>
            </FullyCentered>
        }
    }


    async function getEventByRouteParam() {
        const eventSlug = searchParams.get('evento');
        
        const latParam = searchParams.get('lat')
        const longParam = searchParams.get('long')
       
        const term = searchParams.get('term')
        const filter_date = searchParams.get('filter_date')
        const classification_id = searchParams.get('classification_id')
        const tags = searchParams.get('tags')
        const distance_range = searchParams.get('distance_range')
        const min_date = searchParams.get('min_date')
        const max_date = searchParams.get('max_date')

        if (term || filter_date || classification_id || tags || distance_range || (min_date && max_date)) {
            setFilterData({term, filter_date, classification_id, tags, distance_range, min_date, max_date})
            return
        }

        if (latParam && longParam) {
            renderMultipleEvents(latParam, longParam)
            return
        }

        if (!eventSlug) {
            return
        }

        setCollapse({
            ...collapse,
            withContent: true,
            height: '85vh',
            arrowPosition: false,
            componentToRender: () => (
                <FullyCentered height='100%'>
                    <Loader />
                </FullyCentered>
            )
        })

        try {
            const { data } = await eventsApi.getBySlug(eventSlug);
            setSlug(eventSlug);
            setCollapse({
                ...collapse,
                withContent: true,
                height: '95vh',
                arrowPosition: false,
                componentToRender: () => data && <EventDetail data={data.data} />
            })
        } catch (error) {
            console.log('erro na rota')
        }
    }

    async function getEvents() {
        try {
            const { data } = await eventsApi.get(true);
            const arraysWithMultiple = data.data.filter(obj => obj.hasOwnProperty('multiples'));
            const arraysWithoutMultiple = data.data.filter(obj => !obj.hasOwnProperty('multiples'));
            setEventsList({
                data: arraysWithoutMultiple,
                withMultiples: arraysWithMultiple
            });
        } catch (error) {
            console.log('error G-E')
        }
    }

    function success({ coords }) {
        const { latitude, longitude } = coords;

        setLatitude(latitude);
        setLongitude(longitude);
        setRenderMap(true);
        setScreenLoading(false);

        const data = { lat: latitude, long: longitude }
        setUserLocation(data)
        localStorage.setItem('userLocation', JSON.stringify(data))
    };

    function error() {
        setLatitude(false);
        setLongitude(false);
        setRenderMap(false);
        setScreenLoading(false);
        localStorage.removeItem('userLocation')
        setUserLocation({
            lat: process.env.REACT_APP_BASE_LAT,
            long: process.env.REACT_APP_BASE_LONG
        })
    };

    async function onEventClick(event) {
        let response = false
        setCollapse({
            ...collapse,
            withContent: true,
            height: '85vh',
            arrowPosition: false,
            componentToRender: () => (
                <FullyCentered height='100%'>
                    <Loader />
                </FullyCentered>
            )
        })

        try {
            const { data } = await eventsApi.getBySlug(event.slug)
            response = data
        } catch (error) {
            response = 'error'
        } finally {
            setSearchParams({ evento: event.slug })
            setCollapse({
                ...collapse,
                withContent: true,
                height: '85vh',
                arrowPosition: false,
                componentToRender: () => event && eventDetailToRender(response)
            })
        }
    };

    function eventDetailToRender(response) {
        if (!response) {
            return
        }

        if (response === 'error') {
            return (
                <FullyCentered height='100%'>
                    <Text name='highlight'>Ocorreu um erro inesperado.</Text>
                </FullyCentered>
            )
        }

        return <EventDetail data={response.data} />
    }

    function onEditCollapse() {
        setCollapse({
            ...collapse,
            withContent: true,
            height: '85vh',
            arrowPosition: false,
            componentToRender: () => <EventForm edit={event} />
        })
    }

    function onCloseCollapse() {
        setSearchParams((prevSearchParams) => {
            const newSearchParams = new URLSearchParams(prevSearchParams);
            newSearchParams.delete('evento');
            newSearchParams.delete('lat');
            newSearchParams.delete('long');
            newSearchParams.delete('term');
            newSearchParams.delete('filter_date');
            newSearchParams.delete('classification_id');
            newSearchParams.delete('tags');
            newSearchParams.delete('distance_range');
            newSearchParams.delete('min_date');
            newSearchParams.delete('max_date');
            
            return newSearchParams;
        });

        setCollapse({
            ...collapse,
            withContent: false,
            height: '300px',
            arrowPosition: true,
            componentToRender: false
        });
        
        setBackButtonCollapse({...backButtonCollapse, visible: false});
    };


    function initMap() {
        if (screenLoading && !renderMap) {
            return (
                <FullScreenLoading>
                    <Loader color={colors.neutralLight} size='medium' />
                </FullScreenLoading>
            )
        }

        if (!screenLoading && !renderMap) {
            localStorage.removeItem('userLocation')

            return (
                eventsList?.data && (
                    <Map
                        latitude={Number(process.env.REACT_APP_BASE_LAT)}
                        longitude={Number(process.env.REACT_APP_BASE_LONG)}
                        data={eventsList?.data}
                        multiples={eventsList?.withMultiples}
                        onEventClick={(event) => onEventClick(event)}
                    />
                )
            )
        }

        return (            
            eventsList?.data && (
                <Map
                    withUserLocation
                    latitude={latitude}
                    longitude={longitude}
                    data={eventsList?.data}
                    multiples={eventsList?.withMultiples}
                    onEventClick={(event) => onEventClick(event)}
                />
            )
        )
    }

    return (
        <EventsContainer>
            <BoxFilters
                userLocation={userLocation}
                onClose={() => onCloseCollapse()}
                onEdit={() => onEditCollapse()}
                // onDelete={() => setModalDelete(true)}
                onNearToYouClick={(event) => onEventClick(event)}
                isRouteParam={filterData}
            />

            {/* <FloatingSidebar onCollapseCreateForm={() => console.log('collapse create form')} /> */}

            {initMap()}

            {
                modalDelete && (
                    <DeleteEvent
                        isOpen={modalDelete}
                        setIsOpen={setModalDelete}
                    />
                )
            }
        </EventsContainer>
    );
}

const EventsContainer = styled(Column)`
    width: 100%;
    height: 100vh;
    
    @media screen and (min-width: ${breakpoints.lg}) {
        display:flex;
        flex-direction: row;
    }
`;

const FullScreenLoading = styled(FullyCentered)`
    z-index: ${indexPriority.enormous};
    position: fixed;
    left: ${sizes.none};
    background: rgba(26, 26, 26, .9);
    width: 100%;
    height: 100vh;
    top: ${sizes.none};        
    &:before {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100vh;
        z-index: ${indexPriority.tremendous};
        background: rgba(0, 0, 0, .65);
    }
`;

const CardsContainer = styled(Column)`
    width: 100%;
    height: 100%;
`
